import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, AUTH } from '@const'
import Table from '@tables/table'
import { AddRoleDialog, EditRoleDialog } from '@dialogs'
import { Button, Grid } from '@material-ui/core'
import * as utils from '@utils'
import { Edit } from '@material-ui/icons'

const COMPONENT_GROUP = 'role'

class RolePage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'RolePage')
        }
    }

    state = {
        dataList: []
    }

    actions = []
    columns = [
        {
            field: 's_name',
            title: utils.t('name', 'RolePage')
        },
        {
            field: 'root_role_name',
            title: utils.t('rootRoleId', 'RolePage')
        },
    ]

    componentDidMount() {
        this.updateTableColumns()
        this.queryData()
        if (utils.checkValid(COMPONENT_GROUP + '.add') || utils.checkValid(COMPONENT_GROUP + '.edit') || utils.checkValid(COMPONENT_GROUP + '.delete')) {
            this.actions.push({
                icon: 'loop',
                text: 'refresh',
                isFreeAction: true,
                onClick: () => {
                    this.refreshList()
                },
            })
        }
    }

    updateTableColumns() {
        if (!utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push({
                field: 'edit',
                type: 'edit',
                render: (rowData) => {
                    return (
                        <Button
                            color="primary"
                            variant="contained"
                            className={this.props.classes.button}
                            onClick={() => {
                                this.editDialog.OpenDialog(rowData, this.state.dataList)
                            }}>
                            {this.t('view')}
                        </Button>
                    )
                },
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.edit')) {
            this.columns.push({
                field: 'edit',
                type: 'edit',
                render: (rowData) => {
                    return (
                        <Button
                            style={{ minWidth: '72px' }}
                            onClick={() => {
                                this.editDialog.OpenDialog(rowData, this.state.dataList)
                            }}
                            color="primary"
                            disabled={
                                rowData.id === this.props.auth.userInfo['role_id'] ||
                                (!this.props.auth.isAdmin && rowData.id === rowData['root_role_id'])
                            }>
                            <Edit />
                            {this.t('edit')}
                        </Button>
                    )
                },
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.delete')) {
            this.columns.push({
                field: 'delete',
                type: 'delete',
                apiPath: API.ROLE,
                isDisabled: (rowData) => {
                    return rowData.id === this.props.auth.userInfo['role_id'] || (!this.props.auth.isAdmin && rowData.id === rowData['root_role_id'])
                },
            })
        }

        if (utils.checkValid(COMPONENT_GROUP + '.add')) {
            this.actions.push({
                text: 'add',
                icon: 'add',
                isFreeAction: true,
                onClick: (_evt, _data) => {
                    this.addDialog.OpenDialog(this.state.dataList)
                },
            })
        }
    }

    handleGetRootRoleName(data) {
        const roleMap = utils.ArrayToObject(data, 'id')
        data.forEach((item) => {
            item['root_role_name'] = item['root_role_id'] !== item['id'] && roleMap[item['root_role_id']] ? roleMap[item['root_role_id']]['name'] : ''
        })
    }

    handleGetSubName(data) {
        data.forEach((item) => {
            if (item['id'] === AUTH.ROLE_ID_ADMIN) {
                item['s_name'] = `${item['name']} (${this.t('Administrator')})`
            } else if (item['root_role_id'] === item['id']) {
                item['s_name'] = `${item['name']} (${this.t('rootRole')})`
            } else {
                item['s_name'] = item['name']
            }
        })
    }

    refreshList() {
        this.table.SetLoading(true)
        utils.apiRequest(
            'post',
            API.SUB_PLATFORM_REFRESH,
            null,
            (_data) => {
                window.location.reload()
            },
            null,
            true
        )
    }

    queryData() {
        this.table.SetLoading(true)

        utils.apiRequest(
            'get',
            API.ROLE_LIST,
            {},
            (data) => {
                const dataList = utils.deepCopy(data)
                this.setState({
                    dataList
                })
                this.handleGetRootRoleName(data)
                this.handleGetSubName(data)
                this.table.SetData(data)
            },
            (_err) => {
                this.table.SetData([])
            },
            true
        )
    }

    render() {

        console.log(this.props.auth.userInfo['role_id'])
        console.log(this.props.auth.isAdmin)
        return (
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Table
                        ownerName="RolePage"
                        columns={this.columns}
                        actions={this.actions}
                        onRef={(ref) => (this.table = ref)}
                        queryDataArgs={{
                            apiPath: API.ROLE_LIST,
                            callback: () => {
                                this.queryData()
                            }
                        }}
                    />
                    <AddRoleDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        onRef={(ref) => (this.addDialog = ref)}
                    />
                    <EditRoleDialog
                        confirmCallback={() => {
                            this.queryData()
                        }}
                        onRef={(ref) => (this.editDialog = ref)}
                    />
                </Grid>
            </Grid>
        )
    }
}

const styles = (_theme) => {}

RolePage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
}

export default hoc(styles)(RolePage)
